import { createAction, props } from '@ngrx/store';
import { Action } from '../../models/action';

export const journalUpdate = createAction(
    '[Messages] Received Action Progress Report for Journal',
    props<{ action: Action }>()
);

export const journalInitialize = createAction(
    '[Login] Set initial journal',
    props<{ entries: Action[] }>()
);
